import axiosBase from 'axios'
// import router from '@/router'

// define baseUrl using .env
let baseURL = process.env.VUE_APP_API_URL

// creating axios instance
const axios = axiosBase.create({
  baseURL
})

axios.interceptors.request.use(config => {
  config = handleRequestInterceptor(config)
  return config
})

axios.interceptors.response.use((res) => res, (e) => {
  return Promise.reject(e);
})

function handleRequestInterceptor (config) {
  let sid = localStorage.getItem('sid');
  if (sid) {
    // appends sid to params if they exists, else generates params obj with sid
    config.params = { ...config.params, sid };
  }
  return config;

}

export default axios